import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Buttons from 'theme/components/Buttons.style';
import * as Text from 'theme/components/Text.style';

export const InputContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SwitchWrapper = styled('div')`
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 11px 0;
  box-sizing: border-box;
`;

export const DatePickerWrapper = styled('div')`
  .MuiTextField-root {
    width: 100%;
  }

  .MuiOutlinedInput-root {
    background-color: ${colours.neutral[100]};
    border-radius: 50px;
    border: 2px solid transparent;
    transition: border-color 0.2s ease;

    &:hover,
    &.Mui-focused {
      border-color: ${colours.neutral[300]};
    }

    fieldset {
      border: none;
    }

    input {
      padding: 12px 16px;
      font-size: 16px;
    }
  }
`;

export const InputLabel = styled('label')`
  font-size: 14px;
  font-weight: 500;
  color: black;
`;

export const InputField = styled('input')`
  background-color: ${colours.neutral[100]};
  border: 2px solid transparent;
  border-radius: 50px;
  font-size: 16px;
  padding: 12px 16px;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: ${colours.neutral[400]};
    opacity: 1;
  }

  &:focus,
  &:hover {
    border-color: ${colours.neutral[300]};
  }

  &[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const DateInputWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const DateInputField = styled(InputField)`
  flex: 1;
  border-radius: 50px 0 0 50px;
`;

export const DateTextInputField = styled(InputField)`
  flex: 1;
  border-radius: 50px;
`;

export const DateInputButton = styled('button')`
  background-color: ${colours.neutral[200]};
  border: none;
  outline: none;
  border-radius: 0 50px 50px 0;
  width: 35px;
  height: 46px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
  color: black;
  padding: 0 8px 0 4px;

  &:hover,
  &:focus-visible {
    background-color: ${colours.neutral[300]};
    outline: none;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const NumberInputWrapper = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
`;

export const NumberInputField = styled(InputField)`
  margin-right: 35px;
  flex-grow: 1;
  border-radius: 50px 0 0 50px;
`;

export const NumberInputButtons = styled('div')`
  position: absolute;
  right: 0px;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${colours.neutral[200]};
  border-radius: 0 50px 50px 0;
`;

export const NumberInputButton = styled('button')`
  background-color: ${colours.neutral[200]};
  border: none;
  width: 35px;
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
  padding: 0 5px 0 0;
  color: black;

  &:first-child {
    border-radius: 0 50px 0 0;
  }

  &:last-child {
    border-radius: 0 0 50px 0;
  }

  &:focus-visible,
  &:hover {
    background-color: ${colours.neutral[300]};
    outline: none;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ChoiceInputWrapper = styled('div')`
  .MuiOutlinedInput-root {
    background-color: ${colours.neutral[100]};
    border-radius: 50px;
    border: 2px solid transparent;
    padding: 4px 16px;

    &:hover,
    &.Mui-focused {
      border-color: ${colours.neutral[300]};
    }

    fieldset {
      border: none;
    }
  }

  .MuiAutocomplete-paper {
    margin-top: 8px;
    border-radius: 12px;
    background-color: white !important;
  }

  .MuiAutocomplete-option {
    background-color: ${colours.neutral[100]} !important;
    border-radius: 8px;
    margin: 2px 4px;
    padding: 8px 6px;

    &:hover {
      background-color: ${colours.neutral[100]} !important;
    }

    &[aria-selected='true'] {
      background-color: ${colours.neutral[100]} !important;
    }
  }
`;

export const ReadonlyInputField = styled(Text.P2Semibold)`
  padding: 14px 18px;
  font-size: 16px;
  min-height: 19px;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 364px;
`;

export const MultidateWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MultidateDateRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

export const RemoveDateButton = styled('button')`
  background-color: transparent;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
  color: ${colours.shade[100]};

  &:hover {
    background-color: ${colours.neutral[200]};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const AddDateButton = styled('button')`
  background-color: transparent;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
  color: ${colours.shade[100]};
  align-self: flex-end;

  &:hover {
    background-color: ${colours.neutral[200]};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const FormContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 30px 0;
`;

export const MediumPrimaryButton = styled(Buttons.Primary)`
  max-height: 48px;
`;

export const DownloadButton = styled(MediumPrimaryButton)`
  align-items: center;
  cursor: pointer;
  text-decoration: none;
`;

export const FormButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const FormButton = styled.button`
  border: none;
  width: 42px;
  height: 42px;
  border-radius: 100px;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props) =>
      props.$disabled ? 'transparent' : colours.neutral[300]};
  }

  &:active {
    transform: translateY(1px);
  }

  svg {
    width: 22px;
    height: 22px;
    stroke-width: 2;
    path {
      stroke: ${(props) =>
        props.$disabled ? colours.neutral[400] : colours.neutral[800]};
    }
  }

  p {
    color: black;
  }
`;
